import { Breadcrumbs } from "@/components/Breadcrumbs";

// Iter 102 — Breadcrumbs are now rendered globally by Layout so every
// route gets them consistently. PageHeader only renders its own copy
// when a caller explicitly passes `breadcrumb` or `breadcrumbCurrent`
// to override the auto-derived trail (e.g. a customer's business name
// for /customers/:id). Passing `hideBreadcrumb={true}` is a no-op now
// since the default is to skip.
// `compact` — the h2-sized variant for panels embedded in a Settings tab.
export function PageHeader({ title, subtitle, children, testid, titleAccessory, breadcrumb, breadcrumbCurrent, hideBreadcrumb = true, compact = false }) {
  const showLocalCrumbs = !hideBreadcrumb && (breadcrumb || breadcrumbCurrent);
  const H = compact ? "h2" : "h1";
  return (
    <div className={compact ? "mb-4" : "mb-6"} data-testid={testid}>
      {showLocalCrumbs && <Breadcrumbs trail={breadcrumb} current={breadcrumbCurrent} />}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0">
          <H className={`font-heading flex flex-wrap items-center text-slate-900 dark:text-slate-100 ${compact ? "text-lg font-semibold" : "text-2xl font-bold tracking-tight"}`}>
            <span>{title}</span>
            {titleAccessory}
          </H>
          {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
        </div>
        {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
      </div>
    </div>
  );
}
